import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 终极解决多次触发push或者repalce，报错的问题
// NavigationDuplicated

const originPush = VueRouter.prototype.push
const originReplace = VueRouter.prototype.replace

// location为传过来的对象
VueRouter.prototype.push = function (location, onResolved, onRejected) {
  if (onResolved === undefined && onRejected === undefined) {
    // originPush.call目的是让VueRouter实例化对象去调用‘
    // 如果不加，那就是window在调用
    return originPush.call(this, location).catch(() => {})
  } else {
    return originPush.call(this, location, onResolved, onRejected)
  }
}

VueRouter.prototype.replace = function (location, onResolved, onRejected) {
  if (onResolved === undefined && onRejected === undefined) {
    // originPush.call目的是让VueRouter实例化对象去调用‘
    // 如果不加，那就是window在调用
    return originReplace.call(this, location).catch(() => {})
  } else {
    return originReplace.call(this, location, onResolved, onRejected)
  }
}

const routes = [
  {
    path: '/mainpage',
    name: 'mainpage',
    component: () => import('@/views/userEnd/MainPage.vue')
  },
  {
    path: '/bookTotal',
    name: 'bookTotal',
    component: () => import('@/views/userEnd/BookTotal.vue')
  },
  {
    path: '/watchTotal',
    name: 'watchTotal',
    component: () => import('@/views/userEnd/WatchTotal.vue')
  },
  {
    path: '/fixRecord',
    name: 'fixRecord',
    component: () => import('@/views/userEnd/FixRecord.vue')
  },
  {
    path: '/bookExport',
    name: 'bookExport',
    component: () => import('@/views/userEnd/BookExport.vue')
  },
  {
    path: '/changePassword',
    name: 'changePassword',
    component: () => import('@/views/userEnd/ChangePassword.vue')
  },
  {
    path: '/schoolProfile',
    name: 'schoolProfile',
    component: () => import('@/views/userEnd/SchoolProfile.vue')
  },
  {
    path: '/schoolManager',
    name: 'schoolManager',
    component: () => import('@/views/adminEnd/SchoolManager.vue')
  },
  {
    path: '/whiteList',
    name: 'whiteList',
    component: () => import('@/views/adminEnd/WhiteList.vue')
  },
  {
    path: '/bookRefuse',
    name: 'bookRefuse',
    component: () => import('@/views/adminEnd/BookRefuse.vue')
  },
  {
    path: '/watchSub',
    name: 'watchSub',
    component: () => import('@/views/adminEnd/WatchSub.vue')
  },
  {
    path: '/unfillStatistics',
    name: 'unfillStatistics',
    component: () => import('@/views/adminEnd/UnfillStatistics.vue')
  },
  {
    path: '/bookInput',
    name: 'bookInput',
    component: () => import('@/views/adminEnd/BookInput.vue')
  },
  {
    path: '/timeSet',
    name: 'timeSet',
    component: () => import('@/views/adminEnd/TimeSet.vue')
  },
  {
    path: '/currentTermSet',
    name: 'currentTermSet',
    component: () => import('@/views/adminEnd/CurrentTermSet.vue')
  },
  {
    path: '/fixAudit',
    name: 'fixAudit',
    component: () => import('@/views/adminEnd/FixAudit.vue')
  },
  {
    path: '/priceCheck',
    name: 'priceCheck',
    component: () => import('@/views/adminEnd/PriceCheck.vue')
  },
  {
    path: '/bookManage',
    name: 'bookManage',
    component: () => import('@/views/adminEnd/BookManage.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/adminEnd/Dashboard.vue')
  },
  {
    path: '/exportData',
    name: 'exportData',
    component: () => import('@/views/adminEnd/ExportData.vue')
  },
  {
	  path: '/login',
	  name: 'login',
    type: 'constant',
	  component: () => import('@/views/login/login.vue')
  },
  {
	  path: '/',
	  name: 'login0',
    type: 'constant',
	  component: () => import('@/views/login/login.vue')
  },
  {
    path: '/404',
    name: '404',
    type: 'constant',
    component: () => import('@/views/404.vue')
  }
]

routes.forEach(item => {
  if (item.type !== 'constant') {
    Object.assign(item, {
      beforeEnter: (to, from, next) => {
        if (window.sessionStorage.getItem('token')) {
          next()
        } else {
          next({
            path: '/login'
          })
        }
      }
    })
  }
})
const router = new VueRouter({
  mode: 'hash', // 只有hash模式才能保证地址栏输入时会走路由守卫
  base: process.env.BASE_URL,
  routes
})

export default router
